import { Injectable } from '@angular/core';
import { CanLoad, Route } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginLazyGuard implements CanLoad {
  constructor(
    private authService: AuthService) {
  }
  canLoad(route: Route): boolean {
    if (!this.authService.isAuthenticated()) {
      window.location.href = (`${environment.logoutRedirectUrl}`);
      return false;
    } else {
      return true;
    }
  }
}
